import { textFieldStyles } from '@components/PropertySearchFilters/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { useTranslations } from 'next-intl';
import { FC, useEffect, useRef, useState } from 'react';
import { BetweenDash, ModalHeader, ModalSection, TextContainer } from '../styles';

interface YearSectionProps {
  valArr: (number | null | undefined)[];
  handleDateChange: (date: dayjs.Dayjs | null, val?: boolean) => void;
}

export const YearSection: FC<YearSectionProps> = ({ valArr, handleDateChange }) => {
  const t = useTranslations();
  const datePickerRef = useRef<any | null>(null);
  const [isOpenC1, setIsOpenC1] = useState(false);
  const [isOpenC2, setIsOpenC2] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
        setIsOpenC1(false);
        setIsOpenC2(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <ModalSection>
      <ModalHeader>{t('Years Built')}</ModalHeader>
      <TextContainer ref={datePickerRef}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            views={['year']}
            value={valArr[0] ? dayjs(valArr[0].toString()) : null}
            onChange={(v) => handleDateChange(v, true)}
            maxDate={dayjs()}
            slotProps={{
              textField: {
                size: 'small',
                helperText: null,
                sx: { textFieldStyles },
              },
            }}
            open={isOpenC1}
            onOpen={() => setIsOpenC1(true)}
          />
          <BetweenDash>–</BetweenDash>
          <DatePicker
            views={['year']}
            value={valArr[0] ? dayjs(valArr[0].toString()) : null}
            onChange={(v) => handleDateChange(v, true)}
            maxDate={dayjs()}
            open={isOpenC1}
            onOpen={() => setIsOpenC1(true)}
            slotProps={{
              textField: {
                size: 'small',
                helperText: null,
                sx: { textFieldStyles },
              },
            }}
          />
        </LocalizationProvider>
      </TextContainer>
    </ModalSection>
  );
};
